import React from 'react';
import { LazyMotion } from 'framer-motion';

const loadFeatures = () =>
  import('./motionFeatures').then((mod) => mod.default);

/**
 * Lets the logo and the splash animate without putting framer-motion's animation
 * engine in the startup bundle (they are on the login screen and the app shell).
 * Children use `m.*` instead of `motion.*`; they render at their initial state and
 * start animating once the features load.
 */
const BrandMotion: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <LazyMotion features={loadFeatures}>{children}</LazyMotion>
);

export default BrandMotion;
